import {} from 'react-redux';

import { Action } from '@reduxjs/toolkit';

import * as actionTypes from '../constants/sms-setting';

import { updateObject } from '../../../../shared/utils/utility';

import { AppAction } from '../../../../store';

import { SmsSettingModel } from '../../models';

export type SmsSettingState = {
  smsSetting: SmsSettingModel | null;
  smsSettingError: any | null;
  smsSettingLoading: boolean;

  saveSmsSettingResult: boolean | null;
  saveSmsSettingError: any | null;
  saveSmsSettingLoading: boolean;
};

const initialState: SmsSettingState = {
  smsSetting: null,
  smsSettingError: null,
  smsSettingLoading: false,

  saveSmsSettingResult: null,
  saveSmsSettingError: null,
  saveSmsSettingLoading: false,
};

const getSmsSettingStart = (state: SmsSettingState, action: AppAction<SmsSettingModel>) => {
  return updateObject(state, {
    smsSetting: null,
    smsSettingError: null,
    smsSettingLoading: true,
  });
};

const getSmsSettingSuccess = (state: SmsSettingState, action: AppAction<SmsSettingModel>) => {
  return updateObject(state, {
    smsSetting: action.data,
    smsSettingError: null,
    smsSettingLoading: false,
  });
};

const getSmsSettingFail = (state: SmsSettingState, action: AppAction<SmsSettingModel>) => {
  return updateObject(state, {
    smsSetting: null,
    smsSettingError: action.error,
    smsSettingLoading: false,
  });
};

const saveSmsSettingStart = (state: SmsSettingState, action: AppAction<boolean>) => {
  return updateObject(state, {
    saveSmsSetting: null,
    saveSmsSettingError: null,
    saveSmsSettingLoading: true,
  });
};

const saveSmsSettingSuccess = (state: SmsSettingState, action: AppAction<boolean>) => {
  return updateObject(state, {
    saveSmsSetting: action.data,
    saveSmsSettingError: null,
    saveSmsSettingLoading: false,
  });
};

const saveSmsSettingFail = (state: SmsSettingState, action: AppAction<boolean>) => {
  return updateObject(state, {
    saveSmsSetting: null,
    saveSmsSettingError: action.error,
    saveSmsSettingLoading: false,
  });
};

const reducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case actionTypes.SMS_SETTING_GET_SMS_SETTING_START:
      return getSmsSettingStart(state, action as AppAction<SmsSettingModel>);
    case actionTypes.SMS_SETTING_GET_SMS_SETTING_SUCCESS:
      return getSmsSettingSuccess(state, action as AppAction<SmsSettingModel>);
    case actionTypes.SMS_SETTING_GET_SMS_SETTING_FAIL:
      return getSmsSettingFail(state, action as AppAction<SmsSettingModel>);

    case actionTypes.SMS_SETTING_SAVE_SMS_SETTING_START:
      return saveSmsSettingStart(state, action as AppAction<boolean>);
    case actionTypes.SMS_SETTING_SAVE_SMS_SETTING_SUCCESS:
      return saveSmsSettingSuccess(state, action as AppAction<boolean>);
    case actionTypes.SMS_SETTING_SAVE_SMS_SETTING_FAIL:
      return saveSmsSettingFail(state, action as AppAction<boolean>);

    default:
      return state;
  }
};

export default reducer;
